import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function linkImageToGAFileService(token,data) {
    return axios.post(`${CURRENT_API_URL}/assetgallery/linkImageToGAFile`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Image linked successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while linking image, please try again later.");
        return false;
    });
}

export default linkImageToGAFileService;